<template>
  <div class="spacemanage-container">
    <!-- SpaceManage Header -->
    <div class="spacemanage-header">
      <h1 class="spacemanage-title">
        <slot name="pagename"></slot>
      </h1>

      <a class="close-wrap cursor" tabindex="0" @click="onClickClose" @keydown.enter="onClickClose">
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.81055 7.39387L16.8109 0.393555L18.8105 2.39324L11.8102 9.39355L18.8105 16.3939L16.8109 18.3936L9.81055 11.3932L2.81023 18.3936L0.810547 16.3939L7.81086 9.39355L0.810547 2.39324L2.81023 0.393555L9.81055 7.39387Z"
            fill="white"
          />
        </svg>
      </a>
    </div>

    <!-- Description + ProgressBar -->
    <div class="space-status">
      <h3 class="space-status-text">
        <slot name="spacestatus"></slot>
      </h3>
      <div class="progressbar-wrap">
        <div class="progressbar-fullarea"></div>
        <div class="progressbar-activearea" :style="{ width: `${progress}%` }"></div>
      </div>
    </div>

    <!-- Body -->
    <div class="space-body">
      <slot name="spacebody"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    closefn: {
      type: Function,
      default: () => {},
      required: false
    },
    progress: {
      type: Number,
      default: 0,
      required: false
    }
  },
  mounted() {
    document.querySelector('.app').style.height = '100vh';
  },
  methods: {
    onClickClose() {
      if (this.closefn) {
        this.closefn();
      }
    }
  },
  beforeDestroy() {
    document.querySelector('.app').style.height = '';
  }
};
</script>
<style scoped src="@/assets/css/building/spacemanageslot.css"></style>
